import { createFileRoute } from '@tanstack/react-router';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading } from '@/components/Loading';
import { activeConfig } from '@/config';
import SeeingADoctorPage from '@/components/pages/faq/seeingADoctor';

const ProtectedSeeingADoctorPage = withAuthenticationRequired(
  SeeingADoctorPage,
  {
    onRedirecting: () => <Loading />,
  }
);

export const Route = createFileRoute('/faq/documents/seeingADoctor')({
  head: () => ({
    meta: [{ title: `Seeing a Doctor | ${activeConfig.branding.appName}` }],
  }),
  component: ProtectedSeeingADoctorPage,
});
